import { render, staticRenderFns } from "./list.vue?vue&type=template&id=014c27c7&scoped=true&"
import script from "./list.vue?vue&type=script&lang=tsx&"
export * from "./list.vue?vue&type=script&lang=tsx&"
import style0 from "./list.vue?vue&type=style&index=0&id=014c27c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c27c7",
  null
  
)

export default component.exports